import { useFetchPatientInfo } from '@/api/hooks/useFetchPatientInfo'
import { AppHeader } from '@/components/AppHeader'
import { PatientActionsCta } from '@/components/HomePage/PatientActionsCta'
import { PeakSmileMarquee } from '@/components/HomePage/PeakSmileMarquee'
import { ReferralImageCTA } from '@/components/HomePage/ReferralImageCTA'
import ProtectedPage from '@/components/ProtectedPage'
import heapService from '@/services/heap'
import { Screen } from '@/ui/core/screen'
import { VStack } from '@/ui/core/stack'
import { isEmpty } from 'ramda'
import { useEffect } from 'react'

export default function HomeScreen() {
	const { patientInfo } = useFetchPatientInfo()

	useEffect(() => {
		if (!isEmpty(patientInfo)) {
			heapService.identify(patientInfo)
		}
	}, [patientInfo])

	return (
		<ProtectedPage>
			<Screen preset="fixed" className="flex h-full w-full">
				<AppHeader />
				<VStack className="flex h-auto flex-1 w-full">
					<PatientActionsCta />
					<PeakSmileMarquee />
					<ReferralImageCTA />
				</VStack>
			</Screen>
		</ProtectedPage>
	)
}
